<template>
  <div class="ake_header">
    <span>{{ title }}</span>

    <div>
      <el-tooltip v-if="showClose" content="关闭" placement="top">
        <AkeIcon name="icon_close|svg" size="24" @click="closeModal"></AkeIcon>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },

    modalRef: {
      type: Object,
      default: () => null,
    },

    showClose: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    closeModal() {
      const modalRef = this.modalRef
      if (modalRef && typeof modalRef.close == 'function') {
        modalRef.close()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ake_header {
  flex: 1;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 26px;
  font-size: 18px;
  font-weight: normal;
  color: var(--black_30);

  > div:last-child {
    margin-left: auto;

    .svg-icon {
      cursor: pointer;
    }
  }
}
</style>
